var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    "data-name": "Calque 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.86 118.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afafaf;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.79,95.71c-1.7-2.27-42.6-55.29-94.63-55.29S4.23,93.44,2.54,95.71a6.39,6.39,0,0,0,0,7.74c1.69,2.27,42.59,55.29,94.62,55.29s92.93-53,94.63-55.29A6.42,6.42,0,0,0,191.79,95.71ZM97.16,146c-38,0-71.12-34.6-81.26-46.37C26,87.78,59,53.21,97.16,53.21s71.12,34.6,81.26,46.37C168.28,111.38,135.31,146,97.16,146Z",
    transform: "translate(-1.23 -40.42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.16,71.28a28.3,28.3,0,1,0,28.3,28.3h0A28.34,28.34,0,0,0,97.16,71.28Zm0,43.81a15.51,15.51,0,1,1,15.51-15.51h0A15.54,15.54,0,0,1,97.16,115.09Z",
    transform: "translate(-1.23 -40.42)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePassword);
export default __webpack_public_path__ + "static/media/eye_password.302703e6.svg";
export { ForwardRef as ReactComponent };